import styled from "styled-components";
import MUICheckbox from "@material-ui/core/Checkbox";

export const Checkbox = styled(MUICheckbox)`
  font-size: 0.75rem !important;
`;
